<template>
  <div class="content-container">
    <!-- SEARCH COMPONENT -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col w-33">
              <div class="das-form-input">
                <div class="label">Giai đoạn</div>
                <input
                  v-model="searchParams.keyword"
                  placeholder="Nhập tên/ mã giai đoạn"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        auto-size-cell
        dom-layout="scroll"
        row-multi-select-with-click
        :columns="columns"
        :rows="rows"
        class="agGrid"
        @selectionChanged="onSelectRows"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        :total-size="totalPage"
        target="agGrid"
        :page-num="searchParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <el-col class="bottom-btns-container">
      <div class="button-containers mb-0">
        <button
          :disabled="!enableDelete"
          class="btn primary small outline"
          @click="fnDeleteConfiguration"
        >
          Xóa
        </button>
        <button
          :disabled="!enableEdit"
          class="btn primary small"
          @click="fnOpenEditDialog"
        >
          Sửa
        </button>
        <button class="btn primary small" @click="fnOpenAddDialog">
          Thêm mới
        </button>
      </div>
    </el-col>
    <el-dialog
      :title="!isEditDialog ? 'Thêm giới hạn phòng' : 'Sửa giới hạn phòng'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="520px"
    >
      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã giai đoạn"
                  >
                    <div class="label required">Mã giai đoạn</div>
                    <input
                      v-model="formData.code"
                      :readonly="isEditDialog"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <validation-provider rules="required" name="Tên giai đoạn">
                    <div class="label required">Tên giai đoạn</div>
                    <input
                      v-model="formData.name"
                      :readonly="isEditDialog"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <!-- <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã giai đoạn"
                  > -->
                  <div class="label required">Thời gian áp dụng</div>
                  <CalendarRange v-model="formData.date" mode="date" />
                  <!-- </validation-provider> -->
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <validation-provider rules="max:255" :name="$t('field.desc')">
                    <div class="label">
                      {{ $t('field.desc') }}
                    </div>
                    <textarea
                      v-model="formData.desc"
                      rows="3"
                      style="width: 100%"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <!-- <div class="das-form-col col-6">
                <div class="das-form-input">
                  <validation-provider
                    :name="$t('field.order')"
                    rules="number|min_value:1"
                  >
                    <div class="label">
                      {{ $t('field.order') }}
                    </div>
                    <div>
                      <input
                        v-model="formData.order"
                        v-numeric-only
                        type="number"
                        min="1"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div> -->
            </div>
          </div>
        </validation-observer>

        <div v-loading="loading" class="grid-scroll" style="height: 300px">
          <GridVx
            ref="agGrid2"
            auto-size-cell
            :columns="limitRoomQuantityColumns"
            :rows="limitRoomQuantityRows"
            :context="context"
            dom-layout="scroll"
            class="agGrid"
          />
          <!-- @selectionChanged="onSelectRows" -->
        </div>
      </div>
      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updateConfiguration"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addConfiguration">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { CellRenderNumberInput } from '@/utils/cellRenders.js'

import {
  getPriceCategoryApi,
  deletePriceCategoryApi,
  addPriceCategoryApi,
  updatePriceCategoryApi
} from '@/api/Service_Policy/priceCategory'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import {
  addWebRoomConfigApi,
  deleteWebRoomConfigApi,
  getWebRoomConfigApi,
  updateWebRoomConfigApi
} from '@/api/configuration/webRoomConfig'
import { Message } from 'element-ui'

const CellRenderInputNumber = Vue.extend({
  template: `
  <el-input-number
    class="cell-render-input-number"
    v-model="value" 
    size="mini"
    :min="min" :max="max"
    @blur="changeInput"
    @change="changeInput"
  ></el-input-number>
  `,
  data() {
    return {
      value: null,
      min: 0,
      max: Infinity,
      colName: null
    }
  },
  beforeMount() {
    if (!_.isNil(this.params?.value)) {
      this.value = this.params.value
    }
    if (!_.isNil(this.params?.min)) {
      this.min = this.params.min
    }
    if (!_.isNil(this.params?.max)) {
      this.max = this.params.max
    }
    if (!_.isNil(this.params?.colName)) {
      this.colName = this.params.colName
    }
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.cellInputNumberChange(
        this.params,
        +this.value,
        this.colName
      )
    }
  }
})

const getDefaultForm = () => {
  return {
    id: null,
    name: '',
    code: '',
    desc: '',
    date: {
      start: null,
      end: null
    }
  }
}

export default {
  components: {
    CalendarRange,
    CellRenderNumberInput,
    CellRenderInputNumber
  },
  data() {
    return {
      loading: false,
      formData: {
        id: null,
        name: '',
        code: '',
        desc: '',
        date: {
          start: null,
          end: null
          // start: this.$moment().format('YYYY-MM-DD'),
          // end: this.$moment().format('YYYY-MM-DD')
        }
      },

      // FOR DISABLING BUTTONS
      enableEdit: false,
      enableDelete: false,

      isEditDialog: false,
      dialogFormVisible: false,
      searchParams: {
        keyword: null,
        pageSize: 10,
        pageNum: 1
      },
      totalPage: 0,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 50,
          maxWidth: 50,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã giai đoạn',
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 150
        },
        {
          headerName: 'Tên giai đoạn',
          field: 'name',
          tooltipField: 'name',
          minWidth: 250
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Tổng số lượng phòng',
          field: 'total_quantity',
          minWidth: 170
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Từ ngày',
          field: 'start_date',
          cellRenderer: params => {
            return this.$moment(params.value, 'YYYY-MM-DD').format('DD/MM/YYYY')
          },
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Đến ngày',
          field: 'end_date',
          cellRenderer: params => {
            return this.$moment(params.value, 'YYYY-MM-DD').format('DD/MM/YYYY')
          },
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc',
          wrapText: true,
          autoHeight: true,
          minWidth: 300
          // cellClass: "grid-cell-centered",
        }
      ],
      limitRoomQuantityColumns: [
        {
          headerName: 'Hạng phòng',
          field: 'name',
          // cellClass: "grid-cell-centered",
          minWidth: 300
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          cellRenderer: 'CellRenderInputNumber',
          // cellRenderer: 'CellRenderNumberInput',
          cellRendererParams: params => {
            console.debug(params)
            return {
              value: params.value,
              max: params.data.quantity,
              colName: 'quantity'
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 50
        }
      ],
      limitRoomQuantityRows: [],
      rows: [],
      allRoomLevelData: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetForm()
    }
  },

  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.fnGetAllRoomLevel()
    this.attachData()
  },
  methods: {
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },

    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },

    async fnGetAllRoomLevel() {
      try {
        const res = await getListRoomLevelApi()
        this.allRoomLevelData = res.data
      } catch (error) {}
    },

    onReset() {
      this.searchParams = {
        keyword: null,
        pageSize: 10,
        pageNum: 1
      }
      this.attachData()
    },
    onSearch() {
      this.attachData()
    },
    async attachData() {
      this.loading = true

      const res = await getWebRoomConfigApi(this.searchParams)
      this.totalPage = Math.ceil(res.total / this.searchParams.pageSize)
      this.rows = res.data

      this.loading = false
    },
    async addConfiguration() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      if (!this.formData.date.end || !this.formData.date.start) {
        this.$message({
          type: 'error',
          message: 'Thời gian áp dụng bắt buộc phải nhập'
        })
        return
      }

      const payload = {
        name: this.formData.name,
        code: this.formData.code,
        desc: this.formData.desc,
        start_date: this.formData.date.start,
        end_date: this.formData.date.end,
        data: this.limitRoomQuantityRows
      }

      addWebRoomConfigApi(payload)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updateConfiguration() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      if (!this.formData.date.end || !this.formData.date.start) {
        this.$message({
          type: 'error',
          message: 'Thời gian áp dụng bắt buộc phải nhập'
        })
        return
      }

      const payload = {
        name: this.formData.name,
        code: this.formData.code,
        desc: this.formData.desc,
        start_date: this.formData.date.start,
        end_date: this.formData.date.end,
        data: this.limitRoomQuantityRows
      }

      updateWebRoomConfigApi(this.formData.id, payload)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async fnDeleteConfiguration() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: 'Vui lòng chọn cấu hình'
        })
      } else {
        this.$vxConfirm('Xác nhận xóa cấu hình', {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deleteWebRoomConfigApi({
              ids: id_list
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    onSelectRows(rows) {
      this.enableEdit = rows?.length == 1
      this.enableDelete = !!rows.length
    },
    resetForm() {
      this.formData = getDefaultForm()
    },

    // DIALOG
    fnOpenAddDialog() {
      this.limitRoomQuantityRows = this.allRoomLevelData.map(item => ({
        quantity: item.num_room,
        room_level_id: item.id,
        name: item.name
      }))
      this.isEditDialog = false
      this.dialogFormVisible = true
    },

    fnOpenEditDialog() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowSelected = gridApi.getSelectedRows()[0]
      this.isEditDialog = true
      this.dialogFormVisible = true
      this.formData = {
        id: rowSelected.id,
        code: rowSelected.code,
        desc: rowSelected.desc,
        name: rowSelected.name,
        date: {
          start: rowSelected.start_date,
          end: rowSelected.end_date
        }
      }
      this.limitRoomQuantityRows = rowSelected.data.map(item => ({
        quantity: item.quantity,
        room_level_id: item.room_level_id,
        name: item.room_level_name
      }))
      // this.formData = { ...rowSelected }
    },

    cellInputNumberChange(params, value, colName) {
      this.limitRoomQuantityRows[params.rowIndex][colName] = value
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep {
  .cell-render-input-number {
    .el-input__inner {
      height: 26px !important;
    }
  }
}
</style>
